module.exports = new __parcel__URL__("connected_earth_disasters.67d390cc.png").toString();